import { useEffect } from "react";
import { Col } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import PostCardBody from "./PostCardBody";
import InfiniteScroll from "react-infinite-scroll-component";
import Card from "../../../components/Card";
import { getToken } from "../../../utils/auth";
import loader from "../../../assets/images/page-img/page-load-loader.gif";
import { useTranslation } from "react-i18next";

const PostCard = ({
  post,
  page,
  setPage,
  hasMore,
  handleAllPost,
  handleShowGroupPopup,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (!getToken()) {
      navigate("/auth/sign-in");
    }
  }, []);

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      <InfiniteScroll
        dataLength={post?.length}
        next={() => setPage((page) => page + 1)}
        hasMore={hasMore}
        loader={
          <div className="col-sm-12 text-center">
            <img src={loader} alt="loader" style={{ height: "100px" }} />
          </div>
        }
        endMessage={<p className="text-center">{t("no_more_posts")}</p>}
      >
        {post?.map((data, index) => (
          <Col sm={12} key={index}>
            <Card className=" card-block card-stretch card-height">
              <PostCardBody
                data={data}
                index={index}
                handleAllPost={handleAllPost}
                handleShowGroupPopup={handleShowGroupPopup}
                setPage={setPage}
              />
            </Card>
          </Col>
        ))}
      </InfiniteScroll>
    </>
  );
};

export default PostCard;
